const defaultState = {
    errorMessage: '',
    currentStep: 'preQuoteDisplay',
    openModalKey: '',
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case 'SQR_SET_OPEN_MODAL_KEY':
            return Object.assign({}, state, {
                openModalKey: action.modalKey,
            });
        case 'SQR_SET_ERROR_MSG':
            return Object.assign({}, state, {
                errorMessage: action.errorMessage,
            });
        case 'SQR_SET_CURRENT_STEP':
            return Object.assign({}, state, {
                currentStep: action.step,
            });
        case 'SQR_CLEAR_STATE':
            return defaultState;
        default:
            return state;
    }
};
